<template>
  <ModuleSection title="用户操作日志查询">
    <!-- 查询表单 -->
    <el-form
      ref="queryForm"
      :model="formData"
      label-position="left">
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('业务名称')"
            prop="account"
            >
            <el-select
              v-model="formData.optType"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option
                v-for="(item, key) in businessNameList"
                :key="key"
                :label="$t(item)"
                :value="key" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item
            :label="$t('交易状态')"
            prop="orderState">
            <el-select
              v-model="formData.orderState"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option :label="$t('全部')" value="" />
              <el-option
                v-for="(item, key) in orderStatusList"
                :key="key"
                :label="$t(item)"
                :value="key" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('开始日期')"
            prop="beginDate"
            >
            <el-date-picker
              v-model="formData.beginDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('结束日期')"
            prop="endDate"
            >
            <el-date-picker
              v-model="formData.endDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="display:flex">
          <el-col :span="12" style="margin-right: 40px;">
            <el-form-item
            :label="$t('用户编号')"
            >
           <el-input v-model="formData.userId" :disabled="!isAdmin"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
        </el-col>
      </el-row>
    </el-form>
    <!-- 查询按钮 -->
    <el-row style="margin: 20px 0 40px;">
      <el-button class="btn140" @click="handleQuery()">{{ $t('查询') }}</el-button>
    </el-row>
    <!-- 转账查询列表 -->
    <DataTable
      :data="tableData"
      :loading="tableLoading">
      <el-table-column
        :label="$t('操作时间')"
        width="150"
        prop="operationTime">
        <template slot-scope="scope">
          <p>{{ scope.row.yearOfOperationTime }}</p>
          <p>{{ scope.row.dateOfOperationTime }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('业务名称')"
        width="150"
        prop="logRem">
          <template slot-scope="scope">
            {{ $t(scope.row.logRem) }}
          </template>
       </el-table-column>
      <el-table-column
        :label="$t('指令类型')"
        prop="logIp">
        <template slot-scope="scope">
          {{
            $t($_params.getDisplay('CB_OPERATING_TYPE', scope.row.logIp))
          }}
        </template>
       </el-table-column>
      <el-table-column
        :label="$t('状态')"
        prop="orderState">
        <template slot-scope="scope">
          {{ $t($_params.getDisplay('ORDER_STATUS', scope.row.orderState)) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('用户编号')"
        prop="usernumber">
      </el-table-column>
      <el-table-column
        :label="$t('信息')">
        <template slot-scope="scope">
          <p>{{ scope.row | infoFormat(self) }}</p>
        </template>
      </el-table-column>
    </DataTable>
    <!-- 分页 -->
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      :total="total"
      layout="prev, pager, next, jumper" />
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import { mapState } from 'vuex'
import { userLogQry } from '../api'
import { operationNameConverter } from '@/utils/enum/operation'
export default {
  name: 'QueryLogListCache',
  components: {
    ModuleSection
  },
  data () {
    return {
      self: this,
      /* 查询表单 */
      formData: {
        userId: '',
        optType: '',
        beginDate: '',
        endDate: '',
        orderState: ''
      },
      /* 查询表格 */
      tableData: [],
      tableLoading: false,
      /* 分页 */
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    ...mapState('home', ['sessionInfo']),
    isAdmin () {
      const userRight = this.sessionInfo.userRightType
      const isAdmin = !(userRight === undefined || userRight === null || userRight === 'null' || userRight === '' || userRight.charAt(3) !== '1')
      return isAdmin
    },
    businessNameList () {
      return this.isAdmin ? this.$_params.CB_BSN_NAME2 : this.$_params.CB_BSN_NAME1
    },
    orderStatusList () {
      return this.$_params.ORDER_STATUS
    },
    currencyType () {
      return this.formData.account ? this.$_params.getCurrencyType(this.formData.account.split('|')[0]) : ''
    }
  },
  created () {
    this.formData.endDate = this.$_format.getToday()
    this.formData.beginDate = this.$_format.getLastDay(this.formData.endDate, 7)
    this.formData.userId = this.sessionInfo.session_userId
  },
  activated () {
    this.getTableData()
  },
  methods: {

    /* 表单按钮 */
    // 查询
    getTableData () {
      const { formData, pageNum, pageSize } = this
      this.tableLoading = true
      userLogQry({
        ...formData,
        beginDate: this.$_format.parseDate(formData.beginDate, 'yyyy-mm-dd').format('yyyymmdd') + '0'.repeat(6),
        endDate: this.$_format.parseDate(formData.endDate, 'yyyy-mm-dd').format('yyyymmdd') + '235959',
        turnPageShowNum: pageSize,
        turnPageBeginPos: pageNum,
        pageFlag: 1,
        currentBusinessCode: '99992000',
        EMP_SID: this.$store.state.login.loginInfo.EMP_SID
      }).then(res => {
        this.tableLoading = false
        if (res) {
          const { iLogQueryResult, turnPageTotalNum } = res
          iLogQueryResult.forEach(item => {
            const { operationTime, logRem } = item
            // 处理时间格式
            const timeArr = this.$_format.formatDateTime(operationTime).split(' ')
            item.yearOfOperationTime = timeArr[0]
            item.dateOfOperationTime = timeArr[1]
            // 处理业务名称 operationNameConverter
            item.logRem = operationNameConverter[logRem] || logRem
          })
          this.tableData = iLogQueryResult
          this.total = Number(turnPageTotalNum)
        }
      }).catch(err => {
        this.tableLoading = false
        console.error(err)
      })
    },
    handleQuery () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.pageNum = 1
          this.getTableData()
        }
      })
    },
    /* 分页 */
    handleSizeChange () {
      this.getTableData()
    },
    handleCurrentChange () {
      this.getTableData()
    }
  },
  filters: {
    infoFormat (row, self) {
      const bsnCode = row.operCode
      const reg = new RegExp('\\^', 'g')
      const logInfo1 = (row.logInfo ? row.logInfo : '').replace(reg, '')
      if (row.operationResult !== '00000000' && row.operationResult !== '90000000' && row.orderState !== '99') {
        return logInfo1
      }
      const logInfo = self.$_params.getLogInfoDisplay(bsnCode, row.logInfo, '')
      return logInfo
    },
    translateFilterList (row, self) {
      if (!row) return
      return row.split('；').map(item => {
        if (item && item.includes('：')) {
          const item1 = item.split('：')
          if (item1[1].indexOf(',') > -1) {
            return self.$t(item1[0]) + '：' + item1[1].split(',').map(item => self.$t(item)).join(',')
          } else {
            return self.$t(item1[0]) + '：' + item1[1].split('，').map(item => self.$t(item)).join('，')
          }
        }
      }).join('；')
    }
  }
}
</script>

<style scoped lang="less">
.btn140 {
  min-width: 140px;
}
</style>
